module.exports = __webpack_public_path__ + "img/logo_oncogitiel-old2.47433629.png";